import { createWebHistory, createRouter } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomePage.vue'),
    meta: {
      layout: 'DefaultLayout'
    }
  },
  {
    path: '/eula',
    name: 'eula',
    component: () => import('@/views/EULA.vue'),
    meta: {
      layout: 'DefaultLayout'
    }
  },
  {
    path: '/terms-of-use',
    name: 'terms-of-use',
    component: () => import('@/views/TermsOfUse.vue'),
    meta: {
      layout: 'DefaultLayout'
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import("@/views/PrivacyPolicy.vue"),
    meta: {
      layout: 'DefaultLayout'
    }
  },
  {
    path: '/vpn',
    name: 'vpn-video-1',
    component: () => import("@/views/VpnVideo.vue"),
    meta: {
      layout: 'EmptyLayout'
    }
  }
]

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            el: to.hash,
            top: 0,
            behavior: 'smooth'
          }), 0
        })
      })
    } else {
      return { top: 0, behavior: 'instant' }
    }
  }
})
